<svg
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <defs>
    <symbol id="linkedin" viewBox="0 0 24 24">
      <path
        d="m23.994 24v-.001h.006v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07v-2.185h-4.773v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243v7.801z"
      />
      <path d="m.396 7.977h4.976v16.023h-4.976z" />
      <path
        d="m2.882 0c-1.591 0-2.882 1.291-2.882 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909c-.001-1.591-1.292-2.882-2.882-2.882z"
      />
    </symbol>

    <symbol id="stackoverflow" viewBox="0 0 24 24">
      <path d="m6.444 14.839 10.338 2.196.433-2.089-10.338-2.212z" />
      <path d="m6.215 17.571h10.566v2.127h-10.566z" />
      <path d="m7.8 9.831 9.572 4.526.887-1.944-9.577-4.538z" />
      <path d="m17.373 14.358-.001-.001-.001.001z" />
      <path d="m2 15.429v8.571h18.992v-8.571h-2.113v6.428h-14.766v-6.428z" />
      <path d="m10.453 5.063 8.109 6.873 1.346-1.65-8.109-6.873z" />
      <path d="m22 8.587-6.302-8.587-1.691 1.286 6.302 8.587z" />
    </symbol>

    <symbol id="github" viewBox="0 0 512 512">
      <path
        d="M255.968,5.329C114.624,5.329,0,120.401,0,262.353c0,113.536,73.344,209.856,175.104,243.872
			c12.8,2.368,17.472-5.568,17.472-12.384c0-6.112-0.224-22.272-0.352-43.712c-71.2,15.52-86.24-34.464-86.24-34.464
			c-11.616-29.696-28.416-37.6-28.416-37.6c-23.264-15.936,1.728-15.616,1.728-15.616c25.696,1.824,39.2,26.496,39.2,26.496
			c22.848,39.264,59.936,27.936,74.528,21.344c2.304-16.608,8.928-27.936,16.256-34.368
			c-56.832-6.496-116.608-28.544-116.608-127.008c0-28.064,9.984-51.008,26.368-68.992c-2.656-6.496-11.424-32.64,2.496-68
			c0,0,21.504-6.912,70.4,26.336c20.416-5.696,42.304-8.544,64.096-8.64c21.728,0.128,43.648,2.944,64.096,8.672
			c48.864-33.248,70.336-26.336,70.336-26.336c13.952,35.392,5.184,61.504,2.56,68c16.416,17.984,26.304,40.928,26.304,68.992
			c0,98.72-59.84,120.448-116.864,126.816c9.184,7.936,17.376,23.616,17.376,47.584c0,34.368-0.32,62.08-0.32,70.496
			c0,6.88,4.608,14.88,17.6,12.352C438.72,472.145,512,375.857,512,262.353C512,120.401,397.376,5.329,255.968,5.329z"
      />
    </symbol>

    <symbol id="sign-out" viewBox="0 0 512 512">
      <path
        d="m496 240.007812h-202.667969c-8.832031 0-16-7.167968-16-16 0-8.832031 7.167969-16 16-16h202.667969c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16zm0 0"
      />
      <path
        d="m416 320.007812c-4.097656 0-8.191406-1.558593-11.308594-4.691406-6.25-6.253906-6.25-16.386718 0-22.636718l68.695313-68.691407-68.695313-68.695312c-6.25-6.25-6.25-16.382813 0-22.632813 6.253906-6.253906 16.386719-6.253906 22.636719 0l80 80c6.25 6.25 6.25 16.382813 0 22.632813l-80 80c-3.136719 3.15625-7.230469 4.714843-11.328125 4.714843zm0 0"
      />
      <path
        d="m170.667969 512.007812c-4.566407 0-8.898438-.640624-13.226563-1.984374l-128.386718-42.773438c-17.46875-6.101562-29.054688-22.378906-29.054688-40.574219v-384c0-23.53125 19.136719-42.6679685 42.667969-42.6679685 4.5625 0 8.894531.6406255 13.226562 1.9843755l128.382813 42.773437c17.472656 6.101563 29.054687 22.378906 29.054687 40.574219v384c0 23.53125-19.132812 42.667968-42.664062 42.667968zm-128-480c-5.867188 0-10.667969 4.800782-10.667969 10.667969v384c0 4.542969 3.050781 8.765625 7.402344 10.28125l127.785156 42.582031c.917969.296876 2.113281.46875 3.480469.46875 5.867187 0 10.664062-4.800781 10.664062-10.667968v-384c0-4.542969-3.050781-8.765625-7.402343-10.28125l-127.785157-42.582032c-.917969-.296874-2.113281-.46875-3.476562-.46875zm0 0"
      />
      <path
        d="m325.332031 170.675781c-8.832031 0-16-7.167969-16-16v-96c0-14.699219-11.964843-26.667969-26.664062-26.667969h-240c-8.832031 0-16-7.167968-16-16 0-8.832031 7.167969-15.9999995 16-15.9999995h240c32.363281 0 58.664062 26.3046875 58.664062 58.6679685v96c0 8.832031-7.167969 16-16 16zm0 0"
      />
      <path
        d="m282.667969 448.007812h-85.335938c-8.832031 0-16-7.167968-16-16 0-8.832031 7.167969-16 16-16h85.335938c14.699219 0 26.664062-11.96875 26.664062-26.667968v-96c0-8.832032 7.167969-16 16-16s16 7.167968 16 16v96c0 32.363281-26.300781 58.667968-58.664062 58.667968zm0 0"
      />
    </symbol>

    <symbol id="admin" viewBox="0 0 511 511.9">
      <path
        d="m347.339844 155.148438c-5.519532 0-10 4.46875-10 9.996093 0 5.523438 4.480468 10 10 10 5.53125 0 10-4.476562 10-10 0-5.527343-4.46875-9.996093-10-9.996093zm0 0"
      />
      <path
        d="m165.644531 336.839844c-5.53125 0-10 4.480468-10 10 0 5.53125 4.46875 10 10 10 5.519531 0 10-4.46875 10-10 0-5.519532-4.480469-10-10-10zm0 0"
      />
      <path
        d="m500.058594 61.519531c-3.375-.785156-6.921875.234375-9.359375 2.695313l-41.457031 41.785156h-19.875l-21.878907-22.667969v-20.152343l40.863281-41.472657c2.417969-2.453125 3.402344-5.980469 2.601563-9.335937-.796875-3.351563-3.265625-6.054688-6.53125-7.15625-10.265625-3.460938-21.007813-5.214844-31.933594-5.214844-32.570312 0-62.160156 15.1875-81.183593 41.667969-17.804688 24.789062-23.292969 55.167969-15.429688 84.242187l-73.660156 73.660156-122.71875-123v-24.140624c0-3.511719-1.84375-6.769532-4.855469-8.574219l-70.707031-42.429688c-3.9375-2.363281-8.972656-1.742187-12.214844 1.503907l-28.28125 28.277343c-3.242188 3.246094-3.863281 8.28125-1.503906 12.21875l42.421875 70.707031c1.804687 3.011719 5.058593 4.851563 8.570312 4.855469l24.132813.007813 122.730468 123-73.378906 73.378906c-29.074218-7.859375-59.46875-2.363281-84.269531 15.453125-26.464844 19.011719-41.640625 48.59375-41.640625 81.164063 0 10.921874 1.753906 21.667968 5.214844 31.929687 1.105468 3.285156 3.835937 5.765625 7.210937 6.546875 3.378907.785156 6.921875-.234375 9.363281-2.695312l41.453126-41.78125h19.984374l22.769532 22.769531v19.984375l-41.78125 41.453125c-2.460938 2.441406-3.480469 5.984375-2.695313 9.363281.78125 3.375 3.261719 6.105469 6.546875 7.210938 10.261719 3.460937 21.007813 5.214843 31.929688 5.214843 32.570312 0 62.148437-15.179687 81.164062-41.644531 17.816406-24.800781 23.3125-55.191406 15.453125-84.265625l58.933594-58.933594 13.5 14.664063-6.195313 6.191406c-3.90625 3.90625-3.90625 10.238281 0 14.144531 3.90625 3.902344 10.234376 3.902344 14.144532 0l5.609375-5.609375 126.664062 137.585938c.09375.101562.191407.199218.289063.296875 23.4375 23.4375 61.410156 23.445312 84.859375-.003907 23.382812-23.394531 23.382812-61.460937 0-84.855468-.101563-.101563-.207031-.199219-.3125-.296875l-137.800781-126.421875 5.546874-5.546875c3.90625-3.902344 3.90625-10.234375 0-14.140625s-10.234374-3.90625-14.144531 0l-6.152343 6.15625-14.691407-13.484375 59.21875-59.21875c8.417969 2.25 17.105469 3.390625 25.90625 3.390625 55.140625 0 99.996094-44.859375 99.996094-99.996094 0-10.925781-1.753906-21.667969-5.214844-31.933594-1.105469-3.285156-3.835937-5.765625-7.210937-6.546875zm-411.773438 40.414063c-1.875-1.878906-4.417968-2.835938-7.074218-2.835938l-22.617188-.007812-35.492188-59.257813 17.238282-17.238281 59.15625 35.5v22.617188c0 2.648437 1.050781 5.1875 2.921875 7.0625l125.65625 125.941406-14.144531 14.140625zm254.363282 195.0625 138.269531 126.847656c15.445312 15.609375 15.398437 40.882812-.144531 56.433594-15.578126 15.578125-40.796876 15.625-56.4375.136718l-127.078126-138.035156zm-14.75-13.535156-44.199219 44.191406-13.5-14.664063 43.007812-43.011719zm84.589843-103.464844c-8.746093 0-17.347656-1.402344-25.558593-4.167969-3.597657-1.207031-7.574219-.277344-10.261719 2.40625-50.132813 50.132813-158.15625 158.152344-197.933594 197.933594-2.6875 2.6875-3.621094 6.664062-2.40625 10.265625 8.3125 24.683594 4.335937 51.011718-10.914063 72.242187-15.207031 21.167969-38.871093 33.3125-64.917968 33.3125-2.925782 0-5.835938-.160156-8.71875-.46875l31.761718-31.515625c1.890626-1.875 2.957032-4.429687 2.957032-7.097656v-28.289062c0-2.652344-1.054688-5.195313-2.929688-7.070313l-28.628906-28.628906c-1.875-1.875-4.417969-2.929688-7.070312-2.929688h-28.289063c-2.667969 0-5.222656 1.066407-7.101563 2.957031l-31.511718 31.761719c-.3125-2.882812-.46875-5.792969-.46875-8.71875 0-26.050781 12.140625-49.710937 33.3125-64.917969 21.226562-15.25 47.558594-19.230468 72.246094-10.914062 3.597656 1.214844 7.574218.28125 10.261718-2.40625.550782-.546875 197.792969-197.792969 197.933594-197.933594 2.6875-2.6875 3.617188-6.660156 2.40625-10.261718-8.316406-24.683594-4.347656-51.003907 10.890625-72.21875 15.21875-21.1875 38.886719-33.335938 64.9375-33.335938 3.015625 0 6.011719.167969 8.980469.496094l-31.101563 31.566406c-1.84375 1.871094-2.875 4.390625-2.875 7.015625v28.289063c0 2.59375 1.003907 5.082031 2.804688 6.945312l27.628906 28.628906c1.882813 1.953125 4.480469 3.054688 7.195313 3.054688h28.289062c2.664062 0 5.21875-1.0625 7.097656-2.957032l31.511719-31.757812c.3125 2.882812.46875 5.792969.46875 8.71875 0 44.109375-35.886719 79.996094-79.996094 79.996094zm0 0"
      />
      <path
        d="m311.988281 186.355469-125.136719 125.136719c-3.902343 3.902343-3.902343 10.234374 0 14.140624 3.90625 3.90625 10.238282 3.90625 14.144532 0l125.136718-125.136718c3.90625-3.902344 3.90625-10.234375 0-14.140625s-10.238281-3.90625-14.144531 0zm0 0"
      />
      <path
        d="m438.355469 452c3.90625 3.894531 10.238281 3.894531 14.144531-.023438 3.898438-3.910156 3.886719-10.242187-.023438-14.140624l-90.136718-89.847657c-3.910156-3.898437-10.246094-3.886719-14.140625.023438-3.902344 3.914062-3.890625 10.242187.019531 14.140625zm0 0"
      />
    </symbol>
    <symbol id="key" viewBox="0 0 512 512">
      <g>
        <g>
          <path
            d="M463.748,48.251c-64.336-64.336-169.013-64.335-233.349,0.001c-43.945,43.945-59.209,108.706-40.181,167.461
            L4.396,401.536c-2.813,2.813-4.395,6.621-4.395,10.606V497c0,8.291,6.709,15,15,15h84.858c3.984,0,7.793-1.582,10.605-4.395
            l21.211-21.226c3.237-3.237,4.819-7.778,4.292-12.334l-2.637-22.793l31.582-2.974c7.178-0.674,12.847-6.343,13.521-13.521
            l2.974-31.582l22.793,2.651c4.233,0.571,8.496-0.85,11.704-3.691c3.193-2.856,5.024-6.929,5.024-11.206V363h27.422
            c3.984,0,7.793-1.582,10.605-4.395l38.467-37.958c58.74,19.043,122.381,4.929,166.326-39.046
            C528.084,217.266,528.084,112.587,463.748,48.251z M421.313,154.321c-17.549,17.549-46.084,17.549-63.633,0
            s-17.549-46.084,0-63.633s46.084-17.549,63.633,0S438.861,136.772,421.313,154.321z"
          />
        </g>
      </g>
    </symbol>

    <symbol id="logo" viewBox="0 0 24 24">
      <path
        d="m12 .5c-6.63 0-12 5.28-12 11.792 0 5.211 3.438 9.63 8.205 11.188.6.111.82-.254.82-.567 0-.28-.01-1.022-.015-2.005-3.338.711-4.042-1.582-4.042-1.582-.546-1.361-1.335-1.725-1.335-1.725-1.087-.731.084-.716.084-.716 1.205.082 1.838 1.215 1.838 1.215 1.07 1.803 2.809 1.282 3.495.981.108-.763.417-1.282.76-1.577-2.665-.295-5.466-1.309-5.466-5.827 0-1.287.465-2.339 1.235-3.164-.135-.298-.54-1.497.105-3.121 0 0 1.005-.316 3.3 1.209.96-.262 1.98-.392 3-.398 1.02.006 2.04.136 3 .398 2.28-1.525 3.285-1.209 3.285-1.209.645 1.624.24 2.823.12 3.121.765.825 1.23 1.877 1.23 3.164 0 4.53-2.805 5.527-5.475 5.817.42.354.81 1.077.81 2.182 0 1.578-.015 2.846-.015 3.229 0 .309.21.678.825.56 4.801-1.548 8.236-5.97 8.236-11.173 0-6.512-5.373-11.792-12-11.792z"
      />
    </symbol>
    <symbol id="login" viewBox="0 0 511.999 511.999">
      <g>
        <g>
          <g>
            <path
              d="M418.071,297.743h-40.208H93.929c-31.846,0-57.754,25.909-57.754,57.755s25.909,57.754,57.754,57.754h33.852
              l-4.369,3.549c-5.031,4.088-7.295,10.561-5.909,16.892c1.386,6.332,6.147,11.268,12.426,12.879l2.269,0.583l-11.198,43.629
              c-1.373,5.35,1.851,10.799,7.2,12.172l34.009,8.729c0.819,0.211,1.654,0.314,2.486,0.314c1.776,0,3.537-0.474,5.091-1.393
              c2.283-1.351,3.936-3.553,4.595-6.121l11.199-43.631l2.269,0.583c6.279,1.611,12.828-0.421,17.092-5.304
              c4.264-4.882,5.396-11.645,2.956-17.649l-10.257-25.233h180.223h40.208v0.001c31.846,0,57.754-25.908,57.754-57.754
              S449.915,297.743,418.071,297.743z M134.364,438.712l-0.004,0.015c0.002-0.006,0.003-0.013,0.005-0.019
              C134.364,438.71,134.364,438.711,134.364,438.712z M182.116,439.318c-2.921-0.752-5.959-0.32-8.556,1.216
              c-2.596,1.535-4.438,3.989-5.186,6.907l-10.879,42.387l-14.638-3.758l10.878-42.382c0.751-2.922,0.319-5.961-1.218-8.558
              c-1.537-2.596-3.992-4.438-6.906-5.182l-5.064-1.301l18.953-15.396l12.441-10.106l4.108,10.106l11.123,27.364L182.116,439.318z
               M367.862,393.252H189.51l-4.126-10.15c-1.194-2.936-3.708-5.133-6.778-5.92c-3.072-0.79-6.332-0.075-8.792,1.924L152.4,393.252
              H93.929c-20.818,0-37.754-16.937-37.754-37.754c0-20.818,16.937-37.755,37.754-37.755h273.934V393.252z M418.071,393.252h-30.208
              v-75.509h30.208c20.818,0,37.754,16.937,37.754,37.755C455.824,376.315,438.887,393.252,418.071,393.252z"
            />
            <path
              d="M423.868,332.589c-3.425-4.332-9.714-5.069-14.046-1.642c-4.333,3.425-5.067,9.714-1.642,14.046l6.735,8.519
              l-6.735,8.519c-3.425,4.332-2.69,10.621,1.642,14.046c1.836,1.452,4.023,2.156,6.195,2.156c2.953-0.001,5.877-1.302,7.851-3.798
              l11.64-14.721c2.875-3.635,2.875-8.77,0-12.404L423.868,332.589z"
            />
            <path
              d="M96.979,359.319c0.25,0.61,0.56,1.19,0.92,1.73c0.37,0.55,0.79,1.06,1.25,1.52c0.46,0.461,0.97,0.881,1.52,1.24
              c0.54,0.36,1.12,0.67,1.72,0.92c0.61,0.25,1.23,0.44,1.87,0.57c0.65,0.13,1.3,0.2,1.96,0.2c0.65,0,1.3-0.07,1.95-0.2
              c0.64-0.13,1.27-0.32,1.87-0.57c0.6-0.25,1.19-0.56,1.73-0.92c0.54-0.359,1.06-0.779,1.52-1.24c0.46-0.46,0.88-0.97,1.24-1.52
              c0.36-0.54,0.67-1.12,0.92-1.73c0.25-0.6,0.44-1.229,0.57-1.869c0.13-0.641,0.2-1.301,0.2-1.95c0-0.65-0.07-1.311-0.2-1.96
              c-0.13-0.63-0.32-1.26-0.57-1.87c-0.25-0.601-0.56-1.18-0.92-1.72c-0.36-0.551-0.78-1.061-1.24-1.521
              c-0.46-0.46-0.98-0.88-1.52-1.25c-0.54-0.36-1.13-0.67-1.73-0.92c-0.6-0.25-1.23-0.44-1.87-0.57c-3.25-0.649-6.7,0.41-9.02,2.74
              c-0.46,0.46-0.88,0.97-1.25,1.521c-0.36,0.54-0.67,1.119-0.92,1.72c-0.25,0.61-0.44,1.24-0.57,1.87
              c-0.13,0.649-0.19,1.31-0.19,1.96c0,0.649,0.06,1.31,0.19,1.95S96.729,358.72,96.979,359.319z"
            />
            <path
              d="M150.16,359.319c0.25,0.61,0.56,1.19,0.92,1.73c0.37,0.55,0.79,1.06,1.25,1.52c0.46,0.461,0.97,0.881,1.52,1.24
              c0.54,0.36,1.12,0.67,1.72,0.92c0.61,0.25,1.24,0.44,1.87,0.57c0.65,0.13,1.31,0.2,1.96,0.2s1.31-0.07,1.95-0.2
              c0.64-0.13,1.27-0.32,1.87-0.57c0.61-0.25,1.19-0.56,1.73-0.92c0.55-0.359,1.06-0.779,1.52-1.24c0.46-0.46,0.88-0.97,1.24-1.52
              c0.36-0.54,0.67-1.12,0.92-1.73c0.25-0.6,0.44-1.229,0.57-1.869c0.13-0.641,0.2-1.301,0.2-1.95c0-0.65-0.07-1.311-0.2-1.96
              c-0.13-0.63-0.32-1.26-0.57-1.87c-0.25-0.601-0.56-1.18-0.92-1.72c-0.36-0.551-0.78-1.061-1.24-1.521
              c-2.32-2.33-5.77-3.39-9.03-2.74c-0.63,0.13-1.26,0.32-1.87,0.57c-0.6,0.25-1.18,0.56-1.72,0.92c-0.55,0.37-1.06,0.79-1.52,1.25
              c-0.46,0.46-0.88,0.97-1.25,1.521c-0.36,0.54-0.67,1.119-0.92,1.72c-0.25,0.61-0.44,1.24-0.57,1.87
              c-0.13,0.649-0.19,1.31-0.19,1.96c0,0.649,0.06,1.31,0.19,1.95S149.91,358.72,150.16,359.319z"
            />
            <path
              d="M203.349,359.319c0.25,0.61,0.56,1.19,0.92,1.73c0.36,0.55,0.78,1.06,1.24,1.52c0.46,0.461,0.97,0.881,1.52,1.24
              c0.54,0.36,1.12,0.67,1.73,0.92c0.6,0.25,1.23,0.44,1.87,0.57c0.64,0.13,1.3,0.2,1.95,0.2c0.65,0,1.31-0.07,1.95-0.2
              s1.27-0.32,1.87-0.57c0.61-0.25,1.19-0.56,1.73-0.92c0.55-0.359,1.06-0.779,1.52-1.24c0.46-0.46,0.88-0.97,1.24-1.52
              c0.36-0.54,0.67-1.12,0.92-1.73c0.25-0.6,0.44-1.229,0.57-1.869c0.13-0.641,0.2-1.301,0.2-1.95c0-0.65-0.07-1.311-0.2-1.96
              c-0.12-0.63-0.32-1.26-0.57-1.87c-0.25-0.601-0.56-1.18-0.92-1.72c-0.36-0.551-0.78-1.061-1.24-1.521
              c-2.32-2.33-5.78-3.39-9.02-2.74c-0.64,0.13-1.27,0.32-1.88,0.57c-0.6,0.25-1.18,0.56-1.72,0.92c-0.55,0.37-1.06,0.79-1.52,1.25
              c-0.46,0.46-0.88,0.97-1.24,1.521c-0.36,0.54-0.67,1.119-0.92,1.72c-0.25,0.61-0.45,1.24-0.57,1.87
              c-0.13,0.649-0.2,1.31-0.2,1.96c0,0.649,0.07,1.31,0.2,1.95C202.899,358.09,203.099,358.72,203.349,359.319z"
            />
            <path
              d="M256.53,359.319c0.25,0.61,0.56,1.19,0.92,1.73c0.36,0.55,0.78,1.06,1.24,1.52c0.46,0.461,0.97,0.881,1.52,1.24
              c0.54,0.36,1.12,0.67,1.73,0.92c0.6,0.25,1.23,0.44,1.87,0.57c0.64,0.13,1.3,0.2,1.95,0.2s1.31-0.07,1.95-0.2
              s1.27-0.32,1.87-0.57c0.61-0.25,1.19-0.56,1.73-0.92c0.55-0.359,1.06-0.779,1.52-1.24c0.46-0.46,0.88-0.97,1.24-1.52
              c0.36-0.54,0.67-1.12,0.92-1.73c0.25-0.6,0.45-1.229,0.57-1.869c0.13-0.641,0.2-1.301,0.2-1.95c0-0.65-0.07-1.311-0.2-1.96
              c-0.12-0.63-0.32-1.26-0.57-1.87c-0.25-0.601-0.56-1.18-0.92-1.72c-0.36-0.551-0.78-1.061-1.24-1.521
              c-2.32-2.33-5.78-3.39-9.02-2.74c-0.64,0.13-1.27,0.32-1.87,0.57c-0.61,0.25-1.19,0.56-1.73,0.92c-0.55,0.37-1.06,0.79-1.52,1.25
              c-0.46,0.46-0.88,0.97-1.24,1.521c-0.36,0.54-0.67,1.119-0.92,1.72c-0.25,0.61-0.44,1.24-0.57,1.87
              c-0.13,0.649-0.2,1.31-0.2,1.96c0,0.649,0.07,1.31,0.2,1.95C256.09,358.09,256.28,358.72,256.53,359.319z"
            />
            <path
              d="M309.71,359.319c0.25,0.61,0.56,1.19,0.92,1.73c0.36,0.55,0.78,1.06,1.24,1.52c0.46,0.461,0.97,0.881,1.52,1.24
              c0.54,0.36,1.12,0.67,1.73,0.92c0.6,0.25,1.23,0.44,1.87,0.57c0.64,0.13,1.3,0.2,1.95,0.2s1.31-0.07,1.96-0.2
              c0.63-0.13,1.26-0.32,1.87-0.57c0.6-0.25,1.18-0.56,1.72-0.92c0.55-0.359,1.06-0.779,1.52-1.24c0.46-0.46,0.88-0.97,1.25-1.52
              c0.36-0.54,0.67-1.12,0.92-1.73c0.25-0.6,0.44-1.229,0.57-1.869c0.13-0.641,0.19-1.301,0.19-1.95c0-0.65-0.06-1.311-0.19-1.96
              c-0.13-0.63-0.32-1.26-0.57-1.87c-0.25-0.601-0.56-1.18-0.92-1.72c-0.37-0.551-0.79-1.061-1.25-1.521
              c-0.46-0.46-0.97-0.88-1.52-1.25c-0.54-0.36-1.12-0.67-1.72-0.92c-0.61-0.25-1.24-0.44-1.87-0.57c-1.29-0.26-2.62-0.26-3.91,0
              c-0.64,0.13-1.27,0.32-1.87,0.57c-0.61,0.25-1.19,0.56-1.73,0.92c-0.55,0.37-1.06,0.79-1.52,1.25
              c-0.46,0.46-0.88,0.97-1.24,1.521c-0.36,0.54-0.67,1.119-0.92,1.72c-0.25,0.61-0.44,1.24-0.57,1.87
              c-0.13,0.649-0.2,1.31-0.2,1.96c0,0.649,0.07,1.31,0.2,1.95S309.46,358.72,309.71,359.319z"
            />
            <path
              d="M168.259,252.763c0.245,0.233,0.498,0.459,0.768,0.668c22.963,17.766,50.111,27.821,78.925,29.321
              c0.205,0.011,0.411,0.021,0.616,0.031c0.914,0.044,1.831,0.078,2.748,0.105c0.27,0.008,0.54,0.018,0.81,0.025
              c1.131,0.026,2.263,0.043,3.399,0.043c1.142,0,2.281-0.017,3.419-0.043c0.26-0.006,0.518-0.016,0.777-0.024
              c0.94-0.027,1.877-0.062,2.813-0.107c0.18-0.009,0.359-0.018,0.538-0.028c29.286-1.515,56.797-11.843,79.972-30.112
              c0.318-0.251,0.617-0.522,0.899-0.806C376.267,225.885,397,186.061,397,141.479C397.001,63.467,333.535,0,255.525,0
              S114.046,63.467,114.046,141.478C114.046,186.591,135.27,226.839,168.259,252.763z M268.515,262.259
              c-0.62,0.065-1.241,0.125-1.863,0.181c-0.688,0.063-1.375,0.126-2.066,0.177c-1.199,0.087-2.401,0.157-3.607,0.209
              c-0.413,0.019-0.826,0.033-1.24,0.047c-1.401,0.047-2.805,0.081-4.215,0.081c-1.392,0-2.778-0.033-4.162-0.079
              c-0.408-0.014-0.815-0.029-1.221-0.046c-1.151-0.05-2.298-0.116-3.443-0.197c-0.666-0.048-1.33-0.106-1.993-0.165
              c-0.718-0.063-1.435-0.131-2.151-0.206c-0.799-0.085-1.597-0.173-2.392-0.274c-0.141-0.018-0.281-0.039-0.422-0.057
              c-20.159-2.627-38.78-10.213-54.596-21.493v-18.105c0-23.827,11.834-44.928,29.92-57.779
              c11.304,8.834,25.509,14.119,40.934,14.119s29.631-5.284,40.934-14.119c18.086,12.851,29.92,33.952,29.92,57.779v17.412h0.001
              C310.113,251.929,290.157,259.948,268.515,262.259z M255.525,20c66.983,0,121.478,54.494,121.478,121.478
              c0,30.622-11.394,58.63-30.159,80.018c-0.265-29.199-14.371-55.15-36.064-71.597c7.453-10.756,11.835-23.793,11.835-37.841
              c0-3.305-0.245-6.629-0.729-9.88c-0.813-5.462-5.897-9.231-11.363-8.419c-5.463,0.813-9.232,5.899-8.419,11.362
              c0.339,2.279,0.511,4.613,0.511,6.937c0,10.303-3.366,19.832-9.048,27.557c-4.61,6.268-10.747,11.341-17.859,14.673
              c-5.99,2.807-12.667,4.385-19.707,4.385c-7.04,0-13.717-1.578-19.707-4.385c-7.112-3.332-13.249-8.405-17.859-14.673
              c-5.682-7.725-9.048-17.253-9.048-27.557c0-25.703,20.911-46.614,46.614-46.614c3.538,0,7.061,0.396,10.473,1.179
              c5.389,1.239,10.749-2.129,11.982-7.513c1.234-5.383-2.129-10.747-7.512-11.981c-4.875-1.118-9.903-1.685-14.942-1.685
              c-36.731,0-66.614,29.883-66.614,66.614c0,14.048,4.382,27.085,11.835,37.841c-21.901,16.604-36.075,42.893-36.075,72.433v0.222
              c-19.326-21.518-31.101-49.946-31.101-81.076C134.046,74.494,188.541,20,255.525,20z"
            />
            <path
              d="M288.259,77.37c0.25,0.6,0.56,1.18,0.92,1.72c0.36,0.55,0.78,1.06,1.24,1.52c0.46,0.471,0.97,0.881,1.52,1.25
              c0.54,0.36,1.12,0.671,1.73,0.921c0.6,0.25,1.23,0.439,1.87,0.569s1.3,0.19,1.95,0.19s1.31-0.061,1.95-0.19
              c0.64-0.13,1.27-0.319,1.88-0.569c0.6-0.25,1.18-0.561,1.72-0.921c0.55-0.369,1.06-0.779,1.52-1.25
              c0.46-0.46,0.88-0.97,1.24-1.52c0.36-0.54,0.67-1.12,0.92-1.72c0.25-0.61,0.45-1.23,0.57-1.87c0.13-0.65,0.2-1.3,0.2-1.96
              c0-0.65-0.07-1.311-0.2-1.95c-0.12-0.64-0.32-1.271-0.57-1.87s-0.56-1.189-0.92-1.729c-0.36-0.551-0.78-1.061-1.24-1.521
              c-0.46-0.46-0.97-0.88-1.52-1.24c-0.54-0.359-1.12-0.67-1.72-0.92c-0.61-0.25-1.24-0.439-1.88-0.569
              c-1.29-0.261-2.61-0.261-3.9,0c-0.64,0.13-1.27,0.319-1.87,0.569c-0.61,0.25-1.19,0.561-1.73,0.92
              c-0.55,0.36-1.06,0.78-1.52,1.24c-0.46,0.46-0.88,0.97-1.24,1.521c-0.36,0.54-0.67,1.13-0.92,1.729s-0.44,1.23-0.57,1.87
              c-0.13,0.64-0.2,1.3-0.2,1.95c0,0.66,0.07,1.31,0.2,1.96C287.819,76.14,288.009,76.76,288.259,77.37z"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="arrow-0" viewBox="0 0 56 50">
      <g id="035---Right-Arrows" transform="translate(0 -1)">
        <path
          id="Shape"
          d="m31.17 23.929-21-22c-1.14950289-1.1685422-3.02411343-1.19811912-4.20990865-.06642239s-1.24372299 3.00564545-.13009135 4.20842239c18.281 19.152 18.453 19.279 18.564 19.552.1470936.3036994.1041492.6652128-.11.926-.152.227 1.388-1.408-18.454 19.38-1.14332352 1.1988045-1.09855552 3.0974155.1 4.241 1.2136526 1.1042574 3.08074259 1.0602327 4.241-.1l21-22c1.1081838-1.1580658 1.107743-2.9834696-.001-4.141z"
        />
        <path
          id="Shape"
          d="m3.433 6c-.74205248-1.64673397-.51801333-3.5681675.583-5-1.086 0-2.082-.119-3.087.835-1.17763103 1.11503867-1.24436925 2.96813659-.15 4.165z"
        />
        <path id="Shape" d="m18.898 25h2.235l-16.227-17h-2.231z" />
        <path
          id="Shape"
          d="m3.433 46h-2.654c-.79344791.8777978-.99526976 2.1406455-.51492579 3.2220141.48034397 1.0813687 1.55267244 1.7782388 2.73592579 1.7779859l1.016.0000001c-1.10101333-1.4318326-1.32505248-3.3532661-.583-5.0000001z"
        />
        <path id="Shape" d="m18.898 27-16.222 17h2.23l16.227-17z" />
        <path
          id="Shape"
          d="m27.433 46h-2.654c-.7934479.8777978-.9952698 2.1406455-.5149258 3.2220141.480344 1.0813687 1.5526725 1.7782388 2.7359258 1.7779859l1.016.0000001c-1.1010133-1.4318326-1.3250525-3.3532661-.583-5.0000001z"
        />
        <path id="Shape" d="m42.898 27-16.222 17h2.23l16.226-17z" />
        <path id="Shape" d="m42.898 25h2.234l-16.226-17h-2.23z" />
        <path
          id="Shape"
          d="m34.17 1.929c-.7355173-.79439487-1.8419878-1.13088305-2.8952411-.88047026-1.0532532.25041278-1.8898867 1.04887733-2.1891733 2.08929862s-.0147947 2.1613877.7444144 2.93317164c20.725 21.712 18.493 19.203 18.64 19.929-.152.749 1.8-1.487-18.64 19.929-1.1433235 1.1988045-1.0985555 3.0974155.1 4.241 1.2136526 1.1042574 3.0807426 1.0602327 4.241-.1l21-22c1.1060342-1.1591593 1.1060342-2.9828407 0-4.142z"
        />
        <path
          id="Shape"
          d="m27.433 6c-.7420525-1.64673397-.5180133-3.5681675.583-5-1.084 0-2.08-.12-3.088.835-1.17734 1.11531752-1.2436329 2.96840422-.149 4.165z"
        />
      </g>
    </symbol>

    <symbol id="arrow-1" viewBox="0 0 506.56 506.56">
      <polygon
        points="256,285.28 256,426.144 506.56,253.28 256,80.416 256,221.28 128,221.28 128,253.28 288,253.28 288,141.36 
              450.208,253.28 288,365.2 288,285.28 			"
      />
      <rect x="64" y="221.28" width="32" height="32" />
      <rect x="0" y="221.28" width="32" height="32" />
    </symbol>

    <symbol id="layers" viewBox="0 0 64 64" class="icon-layers">
      <path
        class="icon-layers"
        d="m62 1h-34a1 1 0 0 0 -1 1v5h-5a1 1 0 0 0 -1 1v6h-6a1 1 0 0 0 -1 1v6h-6a1 1 0 0 0 -1 1v5h-5a1 1 0 0 0 -1 1v34a1 1 0 0 0 1 1h34a1 1 0 0 0 1-1v-5h5a1 1 0 0 0 1-1v-6h6a1 1 0 0 0 1-1v-6h6a1 1 0 0 0 1-1v-5h5a1 1 0 0 0 1-1v-34a1 1 0 0 0 -1-1zm-27 60h-32v-32h32zm6-6h-4v-27a1 1 0 0 0 -1-1h-27v-4h32zm7-7h-5v-26a1 1 0 0 0 -1-1h-26v-5h32zm7-7h-5v-26a1 1 0 0 0 -1-1h-26v-5h32zm6-6h-4v-27a1 1 0 0 0 -1-1h-27v-4h32z"
      />
      <path class="icon-layers" d="m45 6h10a1 1 0 0 0 0-2h-10a1 1 0 0 0 0 2z" />
      <path class="icon-layers" d="m58 6h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2z" />
    </symbol>

    <symbol id="binary" viewBox="-1 0 512 512">
      <path
        d="m195 362h-20c-19.300781 0-35 15.699219-35 35v80c0 19.300781 15.699219 35 35 35h20c19.300781 0 35-15.699219 35-35v-80c0-19.300781-15.699219-35-35-35zm5 115c0 2.757812-2.242188 5-5 5h-20c-2.757812 0-5-2.242188-5-5v-80c0-2.757812 2.242188-5 5-5h20c2.757812 0 5 2.242188 5 5zm0 0"
      />
      <path
        d="m75 482h-15v-105c0-8.285156-6.714844-15-15-15h-30c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h15v90h-15c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h60c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15zm0 0"
      />
      <path
        d="m475 362h-20c-19.300781 0-35 15.699219-35 35v80c0 19.300781 15.699219 35 35 35h20c19.300781 0 35-15.699219 35-35v-80c0-19.300781-15.699219-35-35-35zm5 115c0 2.757812-2.242188 5-5 5h-20c-2.757812 0-5-2.242188-5-5v-80c0-2.757812 2.242188-5 5-5h20c2.757812 0 5 2.242188 5 5zm0 0"
      />
      <path
        d="m355 482h-15v-105c0-8.285156-6.714844-15-15-15h-30c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h15v90h-15c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h60c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15zm0 0"
      />
      <path
        d="m195 181h-20c-19.300781 0-35 15.699219-35 35v80c0 19.300781 15.699219 35 35 35h20c19.300781 0 35-15.699219 35-35v-80c0-19.300781-15.699219-35-35-35zm5 115c0 2.757812-2.242188 5-5 5h-20c-2.757812 0-5-2.242188-5-5v-80c0-2.757812 2.242188-5 5-5h20c2.757812 0 5 2.242188 5 5zm0 0"
      />
      <path
        d="m75 301h-15v-105c0-8.285156-6.714844-15-15-15h-30c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h15v90h-15c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h60c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15zm0 0"
      />
      <path
        d="m335 181h-20c-19.300781 0-35 15.699219-35 35v80c0 19.300781 15.699219 35 35 35h20c19.300781 0 35-15.699219 35-35v-80c0-19.300781-15.699219-35-35-35zm5 115c0 2.757812-2.242188 5-5 5h-20c-2.757812 0-5-2.242188-5-5v-80c0-2.757812 2.242188-5 5-5h20c2.757812 0 5 2.242188 5 5zm0 0"
      />
      <path
        d="m495 301h-15v-105c0-8.285156-6.714844-15-15-15h-30c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h15v90h-15c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h60c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15zm0 0"
      />
      <path
        d="m55 0h-20c-19.300781 0-35 15.699219-35 35v80c0 19.300781 15.699219 35 35 35h20c19.300781 0 35-15.699219 35-35v-80c0-19.300781-15.699219-35-35-35zm5 115c0 2.757812-2.242188 5-5 5h-20c-2.757812 0-5-2.242188-5-5v-80c0-2.757812 2.242188-5 5-5h20c2.757812 0 5 2.242188 5 5zm0 0"
      />
      <path
        d="m215 120h-15v-105c0-8.285156-6.714844-15-15-15h-30c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h15v90h-15c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h60c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15zm0 0"
      />
      <path
        d="m475 0h-20c-19.300781 0-35 15.699219-35 35v80c0 19.300781 15.699219 35 35 35h20c19.300781 0 35-15.699219 35-35v-80c0-19.300781-15.699219-35-35-35zm5 115c0 2.757812-2.242188 5-5 5h-20c-2.757812 0-5-2.242188-5-5v-80c0-2.757812 2.242188-5 5-5h20c2.757812 0 5 2.242188 5 5zm0 0"
      />
      <path
        d="m355 120h-15v-105c0-8.285156-6.714844-15-15-15h-30c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h15v90h-15c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h60c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15zm0 0"
      />
    </symbol>

    <symbol id="resume" viewBox="0 0 512 512">
      <g>
        <g>
          <path
            d="M414.007,148.75c5.522,0,10-4.477,10-10V30c0-16.542-13.458-30-30-30h-364c-16.542,0-30,13.458-30,30v452
            c0,16.542,13.458,30,30,30h364c16.542,0,30-13.458,30-30v-73.672c0-5.523-4.478-10-10-10c-5.522,0-10,4.477-10,10V482
            c0,5.514-4.486,10-10,10h-364c-5.514,0-10-4.486-10-10V30c0-5.514,4.486-10,10-10h364c5.514,0,10,4.486,10,10v108.75
            C404.007,144.273,408.485,148.75,414.007,148.75z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M212.007,54c-50.729,0-92,41.271-92,92c0,26.317,11.11,50.085,28.882,66.869c0.333,0.356,0.687,0.693,1.074,1
            c16.371,14.979,38.158,24.13,62.043,24.13c23.885,0,45.672-9.152,62.043-24.13c0.387-0.307,0.741-0.645,1.074-1
            c17.774-16.784,28.884-40.552,28.884-66.869C304.007,95.271,262.736,54,212.007,54z M212.007,218
            c-16.329,0-31.399-5.472-43.491-14.668c8.789-15.585,25.19-25.332,43.491-25.332c18.301,0,34.702,9.747,43.491,25.332
            C243.405,212.528,228.336,218,212.007,218z M196.007,142v-6.5c0-8.822,7.178-16,16-16s16,7.178,16,16v6.5c0,8.822-7.178,16-16,16
            S196.007,150.822,196.007,142z M269.947,188.683c-7.375-10.938-17.596-19.445-29.463-24.697c4.71-6.087,7.523-13.712,7.523-21.986
            v-6.5c0-19.851-16.149-36-36-36s-36,16.149-36,36v6.5c0,8.274,2.813,15.899,7.523,21.986
            c-11.867,5.252-22.088,13.759-29.463,24.697c-8.829-11.953-14.06-26.716-14.06-42.683c0-39.701,32.299-72,72-72s72,32.299,72,72
            C284.007,161.967,278.776,176.73,269.947,188.683z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M266.007,438h-54c-5.522,0-10,4.477-10,10s4.478,10,10,10h54c5.522,0,10-4.477,10-10S271.529,438,266.007,438z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M266.007,382h-142c-5.522,0-10,4.477-10,10s4.478,10,10,10h142c5.522,0,10-4.477,10-10S271.529,382,266.007,382z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M266.007,326h-142c-5.522,0-10,4.477-10,10s4.478,10,10,10h142c5.522,0,10-4.477,10-10S271.529,326,266.007,326z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M88.366,272.93c-1.859-1.86-4.439-2.93-7.079-2.93c-2.631,0-5.211,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07
            s1.069,5.21,2.93,7.07c1.87,1.86,4.439,2.93,7.07,2.93c2.64,0,5.21-1.07,7.079-2.93c1.86-1.86,2.931-4.44,2.931-7.07
            S90.227,274.79,88.366,272.93z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M88.366,328.93c-1.869-1.86-4.439-2.93-7.079-2.93c-2.631,0-5.2,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07
            s1.069,5.21,2.93,7.07c1.87,1.86,4.439,2.93,7.07,2.93c2.64,0,5.21-1.07,7.079-2.93c1.86-1.86,2.931-4.44,2.931-7.07
            S90.227,330.79,88.366,328.93z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M88.366,384.93c-1.869-1.86-4.439-2.93-7.079-2.93c-2.631,0-5.2,1.07-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07
            s1.069,5.21,2.93,7.07c1.859,1.86,4.439,2.93,7.07,2.93c2.64,0,5.22-1.07,7.079-2.93c1.86-1.86,2.931-4.44,2.931-7.07
            S90.227,386.79,88.366,384.93z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M266.007,270h-142c-5.522,0-10,4.477-10,10s4.478,10,10,10h142c5.522,0,10-4.477,10-10S271.529,270,266.007,270z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M491.002,130.32c-9.715-5.609-21.033-7.099-31.871-4.196c-10.836,2.904-19.894,9.854-25.502,19.569L307.787,363.656
            c-0.689,1.195-1.125,2.52-1.278,3.891l-8.858,79.344c-0.44,3.948,1.498,7.783,4.938,9.77c1.553,0.896,3.278,1.34,4.999,1.34
            c2.092,0,4.176-0.655,5.931-1.948l64.284-47.344c1.111-0.818,2.041-1.857,2.73-3.052l125.841-217.963
            C517.954,167.638,511.058,141.9,491.002,130.32z M320.063,426.394l4.626-41.432l28.942,16.71L320.063,426.394z M368.213,386.996
            l-38.105-22l100.985-174.91l38.105,22L368.213,386.996z M489.054,177.693l-9.857,17.073l-38.105-22l9.857-17.073
            c2.938-5.089,7.682-8.729,13.358-10.25c5.678-1.522,11.606-0.74,16.694,2.198c5.089,2.938,8.729,7.682,10.25,13.358
            C492.772,166.675,491.992,172.604,489.054,177.693z"
          />
        </g>
      </g>
    </symbol>

    <symbol id="keyboard" viewBox="0 0 512 512">
      <g>
        <g>
          <path
            d="M484.172,248.641h-78.307c-4.145,0-7.504,3.359-7.504,7.504c0,4.145,3.359,7.504,7.504,7.504h78.307
            c7.07,0,12.821,5.752,12.821,12.822v207.205c0,7.069-5.751,12.821-12.821,12.821H27.828c-7.07,0-12.821-5.752-12.821-12.821
            V276.469c0-7.07,5.751-12.822,12.821-12.822h338.019c4.145,0,7.504-3.359,7.504-7.504c0-4.145-3.359-7.504-7.504-7.504h-76.749
            v-17.913c0-8.698-7.077-15.775-15.775-15.775h-10.738v-12.683c0-11.763,9.57-21.333,21.334-21.333h13.36
            c20.038,0,36.341-16.303,36.341-36.341v-20.363c0-20.038-16.303-36.341-36.341-36.341h-12.44c-11.764,0-21.334-9.57-21.334-21.333
            V8.003c0-4.145-3.359-7.504-7.504-7.504c-4.145,0-7.504,3.359-7.504,7.504v58.555c0,20.038,16.303,36.341,36.341,36.341h12.44
            c11.763,0,21.333,9.57,21.333,21.333v20.363c0,11.763-9.57,21.333-21.333,21.333h-13.36c-20.038,0-36.341,16.303-36.341,36.341
            v12.683h-9.237c-8.698,0-15.775,7.077-15.775,15.775v17.913H27.828C12.483,248.641,0,261.124,0,276.469v207.205
            c0,15.344,12.483,27.828,27.828,27.828h456.345c15.344,0,27.828-12.483,27.828-27.828V276.469
            C512,261.124,499.517,248.641,484.172,248.641z M238.34,229.96h34.982c0.423,0,0.768,0.345,0.768,0.768v17.913h-36.517v-17.913
            h-0.001C237.572,230.305,237.917,229.96,238.34,229.96z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M77.781,283.982h-33.13c-6.695,0-12.141,5.446-12.141,12.141v30.488c0.001,6.695,5.447,12.141,12.141,12.141h33.13
            c6.695,0,12.141-5.446,12.141-12.141v-30.488C89.922,289.428,84.476,283.982,77.781,283.982z M74.915,323.745H47.518V298.99
            h27.397V323.745z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M142.709,283.983h-33.13c-6.695,0-12.141,5.446-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h33.13
            c6.695,0,12.142-5.446,12.142-12.141v-30.488C154.85,289.429,149.403,283.983,142.709,283.983z M139.843,323.745h-27.398V298.99
            h27.398V323.745z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M207.637,283.983h-33.13c-6.695,0-12.141,5.446-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h33.13
            c6.695,0,12.141-5.446,12.141-12.141v-30.488C219.778,289.429,214.332,283.983,207.637,283.983z M204.77,323.745h-27.397V298.99
            h27.397V323.745z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M272.565,283.983h-33.13c-6.695,0-12.141,5.446-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h33.13
            c6.695,0,12.142-5.446,12.142-12.141v-30.488C284.706,289.429,279.259,283.983,272.565,283.983z M269.699,323.745h-27.398V298.99
            h27.398V323.745z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M337.493,283.983h-33.13c-6.695,0-12.141,5.446-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h33.13
            c6.695,0,12.141-5.446,12.141-12.141v-30.488C349.634,289.429,344.188,283.983,337.493,283.983z M334.626,323.745h-27.397V298.99
            h27.397V323.745z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M402.42,283.983h-33.13c-6.695,0-12.141,5.446-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h33.13
            c6.695,0,12.142-5.446,12.142-12.141v-30.488C414.562,289.429,409.115,283.983,402.42,283.983z M399.555,323.745h-27.398V298.99
            h27.398V323.745z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M467.349,283.982h-33.13c-6.695,0-12.141,5.446-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h33.13
            c6.695,0,12.141-5.446,12.141-12.141v-30.488C479.49,289.428,474.044,283.982,467.349,283.982z M464.482,323.745h-27.397V298.99
            h27.397V323.745z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M106.16,356.023H44.651c-6.695,0-12.141,5.446-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h61.509
            c6.695-0.001,12.141-5.447,12.141-12.141v-30.488C118.301,361.469,112.855,356.023,106.16,356.023z M103.294,395.785
            L103.294,395.785H47.518V371.03h55.776V395.785z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M467.349,356.022H405.84c-6.695,0.001-12.141,5.447-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h61.509
            c6.695,0,12.141-5.446,12.141-12.141v-30.488C479.49,361.468,474.044,356.022,467.349,356.022z M464.483,395.785h-55.776V371.03
            h55.776V395.785z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M172.328,356.022h-33.13c-6.695,0.001-12.141,5.447-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h33.13
            c6.695,0,12.142-5.446,12.142-12.141v-30.488C184.47,361.468,179.023,356.022,172.328,356.022z M169.462,395.785h-27.398V371.03
            h27.398V395.785z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M239.153,356.022h-33.13c-6.696,0.001-12.141,5.447-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h33.13
            c6.695,0,12.142-5.446,12.142-12.141v-30.488C251.295,361.468,245.848,356.022,239.153,356.022z M236.287,395.785h-27.398V371.03
            h27.398V395.785z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M305.977,356.022h-33.13c-6.695,0.001-12.141,5.447-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h33.13
            c6.695,0,12.142-5.446,12.142-12.141v-30.488C318.119,361.468,312.672,356.022,305.977,356.022z M303.112,395.785h-27.398V371.03
            h27.398V395.785z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M372.802,356.022h-33.13c-6.695,0.001-12.141,5.447-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h33.13
            c6.695,0,12.142-5.446,12.142-12.141v-30.488C384.944,361.468,379.497,356.022,372.802,356.022z M369.936,395.785h-27.398V371.03
            h27.398V395.785z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M396.566,428.062H175.772c-4.145,0-7.504,3.359-7.504,7.504c0,4.145,3.359,7.504,7.504,7.504h217.927v24.755H118.301
            V443.07h17.574c4.145,0,7.504-3.359,7.504-7.504c0-4.145-3.359-7.504-7.504-7.504h-20.44c-6.695,0-12.141,5.446-12.141,12.141
            v30.488c-0.001,6.695,5.445,12.141,12.14,12.141h281.132c6.695,0,12.141-5.446,12.141-12.141v-30.488
            C408.707,433.508,403.261,428.062,396.566,428.062z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M77.781,428.063h-33.13c-6.695,0-12.141,5.446-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h33.13
            c6.695,0,12.141-5.446,12.141-12.141v-30.488C89.922,433.509,84.476,428.063,77.781,428.063z M74.915,467.825H47.518V443.07
            h27.397V467.825z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M467.349,428.063h-33.13c-6.695,0-12.141,5.446-12.141,12.141v30.488c0,6.695,5.446,12.141,12.141,12.141h33.13
            c6.695,0,12.141-5.446,12.141-12.141v-30.488C479.489,433.509,474.043,428.063,467.349,428.063z M464.482,467.825h-27.397V443.07
            h27.397V467.825z"
          />
        </g>
      </g>
    </symbol>

    <symbol id="files" viewBox="-48 0 480 480">
      <path
        d="m360 0h-352c-4.417969 0-8 3.582031-8 8v464c0 4.417969 3.582031 8 8 8h352c13.253906 0 24-10.746094 24-24v-432c0-13.253906-10.746094-24-24-24zm-344 16h48v448h-48zm272 0h32v48l-9.601562-12.800781c-1.574219-1.914063-3.921876-3.019531-6.398438-3.019531s-4.824219 1.105468-6.398438 3.019531l-9.601562 12.800781zm80 440c0 4.417969-3.582031 8-8 8h-280v-448h192v72c0 3.445312 2.203125 6.5 5.46875 7.589844 3.269531 1.089844 6.863281-.035156 8.929688-2.789063l17.601562-23.464843 17.601562 23.464843c1.507813 2.011719 3.878907 3.199219 6.398438 3.199219.859375-.003906 1.710938-.140625 2.527344-.40625 3.269531-1.089844 5.472656-4.148438 5.472656-7.59375v-72h24c4.417969 0 8 3.582031 8 8zm0 0"
      />
      <path d="m112 80h128v16h-128zm0 0" />
      <path d="m112 48h32v16h-32zm0 0" />
      <path d="m160 48h80v16h-80zm0 0" />
      <path d="m112 128h80v16h-80zm0 0" />
      <path d="m208 128h128v16h-128zm0 0" />
      <path d="m112 160h128v16h-128zm0 0" />
      <path d="m256 160h80v16h-80zm0 0" />
      <path d="m112 192h224v16h-224zm0 0" />
      <path d="m112 224h80v16h-80zm0 0" />
      <path d="m208 224h48v16h-48zm0 0" />
      <path d="m272 224h64v16h-64zm0 0" />
      <path d="m112 256h64v16h-64zm0 0" />
      <path d="m192 256h144v16h-144zm0 0" />
      <path d="m112 288h224v16h-224zm0 0" />
      <path d="m112 320h80v16h-80zm0 0" />
      <path d="m208 320h32v16h-32zm0 0" />
      <path d="m256 320h80v16h-80zm0 0" />
      <path d="m112 352h224v16h-224zm0 0" />
      <path d="m112 384h192v16h-192zm0 0" />
      <path d="m320 384h16v16h-16zm0 0" />
      <path d="m112 416h224v16h-224zm0 0" />
    </symbol>

    <symbol id="file" viewBox="0 0 512 512">
      <g>
        <g>
          <path
            d="M395.459,186.212c-17.56-17.56-40.909-27.231-65.743-27.231c-24.834,0-48.183,9.672-65.743,27.231
            c-36.25,36.251-36.25,95.235,0,131.486c18.125,18.125,41.934,27.187,65.743,27.187c23.809,0,47.617-9.062,65.743-27.187
            C431.71,281.448,431.71,222.464,395.459,186.212z M379.003,301.242c-13.59,13.59-31.436,20.385-49.286,20.382
            c-17.847-0.001-35.7-6.796-49.286-20.382c-27.177-27.176-27.177-71.396,0-98.573c13.164-13.164,30.668-20.416,49.286-20.416
            s36.122,7.251,49.286,20.416C406.18,229.845,406.18,274.065,379.003,301.242z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M340.214,409.961H77.295c-6.427,0-11.636,5.211-11.636,11.636s5.21,11.636,11.636,11.636h262.919
            c6.427,0,11.636-5.211,11.636-11.636S346.641,409.961,340.214,409.961z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M385.713,419.327c-0.151-0.744-0.372-1.477-0.663-2.188c-0.291-0.698-0.652-1.373-1.071-2.001
            c-0.419-0.64-0.908-1.233-1.443-1.769c-2.7-2.7-6.726-3.946-10.508-3.188c-0.733,0.151-1.466,0.371-2.176,0.662
            c-0.698,0.291-1.373,0.653-2.001,1.072c-0.64,0.429-1.233,0.918-1.769,1.455c-0.535,0.535-1.024,1.129-1.455,1.769
            c-0.419,0.628-0.768,1.303-1.059,2.001c-0.291,0.71-0.524,1.443-0.675,2.188c-0.151,0.746-0.221,1.514-0.221,2.269
            c0,0.756,0.07,1.526,0.221,2.269c0.151,0.744,0.384,1.478,0.675,2.176c0.291,0.71,0.64,1.384,1.059,2.012
            c0.431,0.641,0.919,1.235,1.455,1.77s1.129,1.024,1.769,1.443c0.628,0.418,1.303,0.78,2.001,1.071
            c0.71,0.291,1.443,0.511,2.176,0.662c0.756,0.152,1.524,0.233,2.281,0.233s1.524-0.08,2.269-0.233
            c0.745-0.151,1.478-0.371,2.176-0.662c0.71-0.291,1.385-0.653,2.013-1.071c0.64-0.419,1.233-0.908,1.769-1.443
            s1.024-1.129,1.443-1.77c0.419-0.628,0.78-1.302,1.071-2.012c0.291-0.699,0.512-1.431,0.663-2.176
            c0.151-0.745,0.233-1.513,0.233-2.269C385.945,420.841,385.864,420.072,385.713,419.327z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M489.829,395.612l-43.759-43.759v-28.574c13.078-21.247,20.077-45.745,20.077-71.322s-7-50.076-20.077-71.322v-169
            C446.07,5.211,440.861,0,434.434,0H167.711c-0.132,0-0.261,0.015-0.391,0.02c-0.134,0.005-0.266,0.01-0.4,0.02
            c-0.488,0.033-0.968,0.088-1.437,0.179c-0.017,0.004-0.035,0.005-0.052,0.008c-0.512,0.101-1.008,0.244-1.494,0.412
            c-0.094,0.033-0.187,0.068-0.28,0.102c-0.452,0.169-0.891,0.357-1.314,0.578c-0.036,0.019-0.074,0.034-0.111,0.054
            c-0.449,0.24-0.875,0.514-1.287,0.81c-0.098,0.07-0.193,0.143-0.289,0.216c-0.406,0.311-0.799,0.639-1.161,0.998
            c-0.003,0.005-0.009,0.007-0.013,0.012L22.173,140.719c-0.003,0.003-0.007,0.008-0.01,0.013c-0.362,0.363-0.69,0.756-1.001,1.164
            c-0.072,0.094-0.144,0.188-0.213,0.285c-0.296,0.412-0.571,0.84-0.812,1.289c-0.019,0.034-0.031,0.07-0.05,0.104
            c-0.221,0.425-0.412,0.867-0.581,1.32c-0.035,0.094-0.071,0.187-0.104,0.282c-0.166,0.484-0.31,0.98-0.411,1.491
            c-0.005,0.022-0.006,0.044-0.01,0.065c-0.09,0.463-0.144,0.939-0.177,1.421c-0.009,0.137-0.016,0.273-0.021,0.412
            c-0.005,0.128-0.02,0.255-0.02,0.384v351.418c0,6.426,5.21,11.636,11.636,11.636h404.034c6.427,0,11.636-5.211,11.636-11.636
            V384.767l27.304,27.302c2.271,2.271,5.25,3.408,8.228,3.408c2.978,0,5.957-1.137,8.228-3.408
            C494.374,407.524,494.374,400.156,489.829,395.612z M156.075,39.73v97.579H58.496L156.075,39.73z M422.803,488.727h-0.006H42.038
            V160.582h125.673c6.427,0,11.636-5.211,11.636-11.636V23.273h243.45v128.933c-0.237-0.221-0.479-0.434-0.718-0.654
            c-0.467-0.431-0.934-0.858-1.407-1.281c-0.321-0.287-0.644-0.571-0.967-0.855c-0.575-0.506-1.153-1.008-1.735-1.503
            c-0.207-0.176-0.415-0.35-0.623-0.525c-0.725-0.609-1.455-1.211-2.189-1.804c-0.051-0.042-0.102-0.083-0.155-0.123
            c-24.122-19.394-53.893-29.936-85.288-29.936c-35.024,0-68.031,13.115-93.423,37.013c-0.2,0.189-0.404,0.371-0.603,0.561
            c-0.156,0.148-0.308,0.302-0.463,0.453c-0.664,0.638-1.328,1.279-1.983,1.934c-11.27,11.27-20.143,24.041-26.637,37.672
            c-17.741,37.232-17.666,80.895,0.225,118.072c6.474,13.454,15.272,26.061,26.412,37.201c0.826,0.826,1.661,1.638,2.502,2.439
            c0.179,0.17,0.362,0.334,0.541,0.503c0.661,0.621,1.323,1.242,1.994,1.847c0.297,0.269,0.599,0.528,0.898,0.794
            c0.56,0.497,1.117,0.995,1.683,1.481c0.347,0.298,0.699,0.586,1.05,0.881c0.525,0.441,1.047,0.887,1.577,1.318
            c0.379,0.31,0.763,0.609,1.145,0.913c0.506,0.404,1.01,0.811,1.52,1.207c0.405,0.314,0.816,0.619,1.223,0.927
            c0.493,0.375,0.986,0.752,1.484,1.118c0.425,0.313,0.853,0.616,1.28,0.922c0.488,0.35,0.973,0.704,1.464,1.046
            c0.439,0.307,0.882,0.604,1.324,0.905c0.486,0.332,0.97,0.666,1.46,0.99c0.45,0.298,0.905,0.588,1.359,0.881
            c0.485,0.313,0.97,0.63,1.458,0.936c0.465,0.291,0.934,0.575,1.401,0.86c0.482,0.294,0.964,0.591,1.449,0.879
            c0.479,0.285,0.964,0.561,1.446,0.839c0.478,0.276,0.955,0.554,1.436,0.824c0.491,0.276,0.986,0.543,1.48,0.812
            c0.479,0.261,0.958,0.524,1.438,0.777c0.499,0.264,1.001,0.519,1.502,0.776c0.481,0.247,0.961,0.495,1.444,0.734
            c0.51,0.254,1.022,0.5,1.534,0.747c0.479,0.232,0.958,0.463,1.439,0.689c0.518,0.242,1.038,0.477,1.558,0.712
            c0.482,0.218,0.962,0.436,1.445,0.648c0.525,0.23,1.052,0.454,1.58,0.677c0.481,0.204,0.961,0.407,1.444,0.605
            c0.535,0.219,1.073,0.433,1.61,0.645c0.478,0.189,0.958,0.378,1.438,0.561c0.545,0.208,1.091,0.41,1.637,0.611
            c0.477,0.176,0.955,0.35,1.435,0.52c0.55,0.195,1.102,0.385,1.654,0.573c0.481,0.163,0.961,0.326,1.443,0.484
            c0.556,0.183,1.114,0.36,1.671,0.534c0.479,0.15,0.959,0.299,1.439,0.443c0.563,0.17,1.129,0.335,1.694,0.498
            c0.478,0.137,0.957,0.273,1.436,0.405c0.57,0.157,1.142,0.31,1.714,0.46c0.477,0.125,0.954,0.247,1.431,0.367
            c0.578,0.145,1.157,0.285,1.736,0.421c0.474,0.112,0.948,0.221,1.423,0.328c0.585,0.132,1.171,0.259,1.756,0.383
            c0.474,0.1,0.947,0.198,1.422,0.292c0.588,0.118,1.175,0.232,1.764,0.341c0.474,0.088,0.948,0.173,1.423,0.257
            c0.592,0.104,1.186,0.205,1.779,0.301c0.472,0.077,0.945,0.15,1.418,0.221c0.598,0.091,1.195,0.178,1.794,0.261
            c0.469,0.065,0.938,0.126,1.408,0.186c0.605,0.077,1.209,0.151,1.815,0.22c0.465,0.052,0.931,0.101,1.398,0.15
            c0.61,0.063,1.219,0.124,1.83,0.179c0.462,0.042,0.925,0.079,1.388,0.116c0.614,0.049,1.229,0.097,1.844,0.137
            c0.46,0.03,0.92,0.056,1.38,0.081c0.619,0.035,1.237,0.069,1.856,0.095c0.457,0.02,0.916,0.034,1.373,0.049
            c0.62,0.021,1.24,0.04,1.862,0.051c0.456,0.008,0.912,0.012,1.368,0.016c0.425,0.003,0.851,0.015,1.275,0.015
            c0.199,0,0.398-0.006,0.597-0.007c0.453-0.002,0.904-0.01,1.357-0.016c0.626-0.008,1.253-0.019,1.879-0.036
            c0.449-0.013,0.898-0.03,1.347-0.048c0.631-0.024,1.261-0.048,1.892-0.08c0.442-0.023,0.884-0.051,1.327-0.079
            c0.636-0.04,1.272-0.078,1.907-0.126c0.436-0.033,0.873-0.072,1.31-0.109c0.639-0.053,1.278-0.107,1.915-0.171
            c0.434-0.043,0.867-0.093,1.301-0.14c0.641-0.07,1.282-0.138,1.922-0.216c0.427-0.052,0.854-0.113,1.281-0.169
            c0.643-0.085,1.288-0.17,1.93-0.264c0.421-0.062,0.841-0.131,1.261-0.197c0.649-0.101,1.297-0.201,1.946-0.312
            c0.41-0.07,0.817-0.148,1.225-0.221c0.656-0.119,1.311-0.235,1.967-0.363c0.4-0.078,0.798-0.164,1.197-0.246
            c0.662-0.136,1.324-0.269,1.984-0.414c0.386-0.085,0.771-0.178,1.158-0.266c0.67-0.154,1.341-0.306,2.008-0.469
            c0.369-0.091,0.735-0.19,1.103-0.283c0.684-0.173,1.37-0.346,2.052-0.531c0.334-0.091,0.666-0.19,0.998-0.283
            c0.713-0.199,1.427-0.396,2.136-0.606c0.28-0.083,0.559-0.173,0.839-0.258c0.761-0.232,1.521-0.462,2.278-0.706
            c0.136-0.044,0.272-0.093,0.408-0.137c2.837-0.925,5.648-1.946,8.431-3.062c0.107-0.043,0.215-0.083,0.324-0.127
            c0.661-0.266,1.316-0.547,1.974-0.824c0.356-0.15,0.713-0.294,1.067-0.448c0.592-0.256,1.18-0.525,1.77-0.79
            c0.413-0.186,0.829-0.365,1.24-0.556c0.557-0.257,1.111-0.527,1.665-0.792c0.441-0.211,0.883-0.417,1.322-0.632
            c0.527-0.259,1.051-0.531,1.576-0.797c0.462-0.235,0.925-0.464,1.385-0.704c0.507-0.265,1.011-0.541,1.516-0.815
            c0.471-0.254,0.944-0.504,1.411-0.763c0.491-0.272,0.977-0.555,1.466-0.833c0.478-0.273,0.959-0.542,1.434-0.823
            c0.476-0.279,0.947-0.568,1.42-0.853c0.482-0.291,0.966-0.58,1.445-0.876c0.464-0.289,0.925-0.585,1.386-0.881
            c0.483-0.307,0.966-0.613,1.445-0.927c0.453-0.297,0.901-0.603,1.351-0.905c0.483-0.325,0.966-0.648,1.445-0.98
            c0.442-0.306,0.881-0.621,1.321-0.933c0.479-0.34,0.96-0.678,1.436-1.026c0.433-0.315,0.862-0.639,1.292-0.961
            c0.478-0.357,0.955-0.713,1.43-1.078c0.422-0.323,0.84-0.655,1.259-0.986c0.475-0.374,0.95-0.747,1.42-1.128
            c0.413-0.335,0.823-0.676,1.233-1.017c0.3-0.249,0.604-0.492,0.903-0.744l5.186,5.186V488.727z M424.708,313.498
            c-0.01,0.016-0.023,0.031-0.034,0.048c-0.534,0.822-1.079,1.636-1.635,2.445c-0.005,0.006-0.009,0.013-0.014,0.02
            c-0.527,0.766-1.066,1.526-1.613,2.278c-0.051,0.07-0.101,0.141-0.151,0.209c-0.507,0.695-1.024,1.384-1.548,2.068
            c-0.085,0.111-0.169,0.222-0.254,0.334c-0.493,0.639-0.996,1.273-1.502,1.903c-0.116,0.144-0.23,0.29-0.348,0.434
            c-0.479,0.589-0.968,1.172-1.459,1.751c-0.149,0.175-0.294,0.353-0.443,0.527c-0.464,0.542-0.938,1.076-1.413,1.609
            c-0.18,0.202-0.357,0.408-0.54,0.61c-0.455,0.504-0.919,1-1.384,1.496c-0.206,0.22-0.407,0.443-0.614,0.661
            c-0.545,0.573-1.097,1.136-1.654,1.697c-0.126,0.126-0.247,0.256-0.372,0.382c-17.922,17.926-40.413,28.568-63.759,31.929
            c-16.163,2.327-32.737,1.164-48.49-3.491c-17.503-5.17-33.993-14.649-47.781-28.437c-44.12-44.12-44.12-115.909,0-160.029
            c0.022-0.022,0.044-0.043,0.065-0.064c1.35-1.347,2.725-2.655,4.125-3.92c0.028-0.026,0.057-0.05,0.085-0.076
            c42.909-38.699,108.545-38.704,151.46-0.016c0.036,0.033,0.074,0.065,0.111,0.098c1.389,1.256,2.754,2.554,4.095,3.891
            c0.029,0.029,0.059,0.057,0.088,0.087c0.29,0.29,0.57,0.585,0.856,0.877c0.389,0.397,0.781,0.791,1.164,1.194
            c0.195,0.206,0.385,0.417,0.579,0.624c0.485,0.518,0.969,1.036,1.444,1.562c0.12,0.133,0.235,0.268,0.354,0.4
            c0.548,0.613,1.093,1.229,1.627,1.854c0.062,0.072,0.121,0.144,0.182,0.216c0.592,0.696,1.178,1.396,1.752,2.105
            c0.012,0.014,0.022,0.028,0.034,0.043c2.488,3.07,4.81,6.262,6.952,9.555c0.029,0.044,0.062,0.084,0.091,0.127
            c11.783,18.143,18.109,39.312,18.109,61.456C442.873,274.134,436.527,295.334,424.708,313.498z"
          />
        </g>
      </g>
    </symbol>

    <symbol id="menu" viewBox="0 0 24.75 24.75">
      <g>
        <path
          d="M0,3.875c0-1.104,0.896-2,2-2h20.75c1.104,0,2,0.896,2,2s-0.896,2-2,2H2C0.896,5.875,0,4.979,0,3.875z M22.75,10.375H2
          c-1.104,0-2,0.896-2,2c0,1.104,0.896,2,2,2h20.75c1.104,0,2-0.896,2-2C24.75,11.271,23.855,10.375,22.75,10.375z M22.75,18.875H2
          c-1.104,0-2,0.896-2,2s0.896,2,2,2h20.75c1.104,0,2-0.896,2-2S23.855,18.875,22.75,18.875z"
        />
      </g>
    </symbol>

    <symbol id="dashboard" viewBox="0 0 512 512">
      <path
        d="m197.332031 170.667969h-160c-20.585937 0-37.332031-16.746094-37.332031-37.335938v-96c0-20.585937 16.746094-37.332031 37.332031-37.332031h160c20.589844 0 37.335938 16.746094 37.335938 37.332031v96c0 20.589844-16.746094 37.335938-37.335938 37.335938zm-160-138.667969c-2.941406 0-5.332031 2.390625-5.332031 5.332031v96c0 2.945313 2.390625 5.335938 5.332031 5.335938h160c2.945313 0 5.335938-2.390625 5.335938-5.335938v-96c0-2.941406-2.390625-5.332031-5.335938-5.332031zm0 0"
      />
      <path
        d="m197.332031 512h-160c-20.585937 0-37.332031-16.746094-37.332031-37.332031v-224c0-20.589844 16.746094-37.335938 37.332031-37.335938h160c20.589844 0 37.335938 16.746094 37.335938 37.335938v224c0 20.585937-16.746094 37.332031-37.335938 37.332031zm-160-266.667969c-2.941406 0-5.332031 2.390625-5.332031 5.335938v224c0 2.941406 2.390625 5.332031 5.332031 5.332031h160c2.945313 0 5.335938-2.390625 5.335938-5.332031v-224c0-2.945313-2.390625-5.335938-5.335938-5.335938zm0 0"
      />
      <path
        d="m474.667969 512h-160c-20.589844 0-37.335938-16.746094-37.335938-37.332031v-96c0-20.589844 16.746094-37.335938 37.335938-37.335938h160c20.585937 0 37.332031 16.746094 37.332031 37.335938v96c0 20.585937-16.746094 37.332031-37.332031 37.332031zm-160-138.667969c-2.945313 0-5.335938 2.390625-5.335938 5.335938v96c0 2.941406 2.390625 5.332031 5.335938 5.332031h160c2.941406 0 5.332031-2.390625 5.332031-5.332031v-96c0-2.945313-2.390625-5.335938-5.332031-5.335938zm0 0"
      />
      <path
        d="m474.667969 298.667969h-160c-20.589844 0-37.335938-16.746094-37.335938-37.335938v-224c0-20.585937 16.746094-37.332031 37.335938-37.332031h160c20.585937 0 37.332031 16.746094 37.332031 37.332031v224c0 20.589844-16.746094 37.335938-37.332031 37.335938zm-160-266.667969c-2.945313 0-5.335938 2.390625-5.335938 5.332031v224c0 2.945313 2.390625 5.335938 5.335938 5.335938h160c2.941406 0 5.332031-2.390625 5.332031-5.335938v-224c0-2.941406-2.390625-5.332031-5.332031-5.332031zm0 0"
      />
    </symbol>

    <symbol id="about" viewBox="0 0 512 512">
      <g>
        <g>
          <g>
            <path
              d="M8.533,119.467c2.264,0.001,4.435-0.897,6.035-2.498s2.499-3.772,2.498-6.035V25.6c0.003-4.711,3.822-8.53,8.533-8.533
              h85.333c4.713,0,8.533-3.82,8.533-8.533S115.646,0,110.933,0H25.6C11.468,0.015,0.015,11.468,0,25.6v85.333
              c-0.001,2.264,0.897,4.435,2.498,6.035S6.27,119.468,8.533,119.467z"
            />
            <path
              d="M486.4,0h-85.333c-4.713,0-8.533,3.82-8.533,8.533s3.821,8.533,8.533,8.533H486.4c4.712,0.003,8.53,3.822,8.533,8.533
              v85.333c0,4.713,3.82,8.533,8.533,8.533s8.533-3.82,8.533-8.533V25.6C511.985,11.468,500.532,0.015,486.4,0z"
            />
            <path
              d="M503.467,392.533c-2.264-0.001-4.435,0.897-6.035,2.498c-1.601,1.601-2.499,3.772-2.498,6.035V486.4
              c-0.003,4.712-3.822,8.53-8.533,8.533h-85.333c-4.713,0-8.533,3.82-8.533,8.533s3.821,8.533,8.533,8.533H486.4
              c14.132-0.015,25.585-11.468,25.6-25.6v-85.333c0.001-2.264-0.897-4.435-2.498-6.035
              C507.901,393.431,505.73,392.532,503.467,392.533z"
            />
            <path
              d="M110.933,494.933H25.6c-4.711-0.003-8.53-3.822-8.533-8.533v-85.333c0-4.713-3.82-8.533-8.533-8.533S0,396.354,0,401.067
              V486.4c0.015,14.132,11.468,25.585,25.6,25.6h85.333c4.713,0,8.533-3.82,8.533-8.533S115.646,494.933,110.933,494.933z"
            />
            <path
              d="M503.467,162.133h-86.42c-0.535-16.481-3.953-32.74-10.097-48.042C389.433,78.517,337.8,25.6,267.342,25.6h-22.683
              c-70.458,0-122.092,52.917-139.608,88.492c-6.144,15.302-9.561,31.561-10.095,48.042H8.533c-4.713,0-8.533,3.82-8.533,8.533
              s3.82,8.533,8.533,8.533H94.08c-0.185,6.252-0.236,12.426-0.194,18.352c-1.55-0.504-3.14-0.875-4.752-1.11
              c-8.173-1.019-16.352,1.842-22.108,7.733c-6.724,8.586-9.113,19.793-6.475,30.375c2.23,11.462,5.439,22.711,9.591,33.625
              l1.45,4.175c1.017,2.933,1.875,6.033,2.742,9.142c1.861,8.559,5.215,16.722,9.908,24.117c3.729,5.669,9.802,9.369,16.55,10.083
              c0.408,0.025,0.842,0.042,1.292,0.042c0.356,0,0.778-0.081,1.155-0.103c0.566,7.799,0.936,14.797,0.936,19.903
              c0,29.183,27.458,64.867,43.692,81.35c9.386,9.094,19.246,17.683,29.541,25.733c9.819,7.665,19.227,15.843,28.183,24.5
              c10.102,11.155,24.069,18.049,39.067,19.283h22.683c14.998-1.234,28.965-8.128,39.067-19.283
              c8.955-8.65,18.357-16.825,28.167-24.492c10.305-8.053,20.175-16.649,29.567-25.75c16.225-16.475,43.683-52.158,43.683-81.342
              c0-5.105,0.37-12.103,0.936-19.903c0.377,0.022,0.799,0.103,1.155,0.103c0.45,0,0.883-0.017,1.292-0.042
              c6.761-0.719,12.844-4.432,16.575-10.117c4.681-7.386,8.026-15.538,9.883-24.083c0.867-3.108,1.725-6.208,2.742-9.142l1.45-4.175
              c4.15-10.905,7.356-22.146,9.583-33.6c2.65-10.597,0.253-21.824-6.492-30.417c-5.749-5.885-13.92-8.74-22.083-7.717
              c-1.611,0.235-3.199,0.607-4.747,1.11c0.041-5.924-0.01-12.098-0.196-18.352h85.544c4.713,0,8.533-3.82,8.533-8.533
              S508.18,162.133,503.467,162.133z M98.083,295.625c-3.448-5.795-5.917-12.119-7.308-18.717c-0.967-3.45-1.925-6.883-3.05-10.142
              l-1.475-4.225c-3.83-10.012-6.799-20.333-8.875-30.85c-1.486-5.169-0.872-10.715,1.708-15.433
              c2.115-2.172,5.124-3.229,8.133-2.859c2.667,0.376,5.151,1.57,7.11,3.418c0.586,15.309,1.54,26.291,1.665,27.666
              c0.048,0.429,3.432,28.052,5.833,54.143C100.253,298.116,98.923,297.048,98.083,295.625z M111.55,210.917
              c-0.105-0.167-0.252-0.29-0.359-0.454c-0.275-9.848-0.33-20.575-0.009-31.262H128v27.766l-16.394,4.097
              C111.578,211.017,111.579,210.963,111.55,210.917z M136.533,375.273c-8.507-11.669-13.783-25.378-15.292-39.74
              c0-7.931-0.781-19.746-1.863-32.313c0.001-0.507-0.044-1.013-0.135-1.511c-1.796-20.506-4.319-42.543-5.553-52.944l22.843,27.4
              V375.273z M117.848,227.088l19.21-4.796l60.371,7.538l5.791,34.704h-54.162L117.848,227.088z M145.067,206.092V179.2h28.845
              l16.169,32.515L145.067,206.092z M192.975,179.2h42.506l-28.337,28.494L192.975,179.2z M153.6,291.875l48.16,42.139
              l-18.29,24.386H153.6V291.875z M165.283,409.948c-1.822-1.689-3.617-3.374-5.258-5.04c-2.034-2.066-4.201-4.41-6.425-6.955
              v-22.487h29.871l16.203,21.603L165.283,409.948z M217.758,455.133c-9.4-9.107-19.278-17.708-29.592-25.767
              c-2.728-2.217-5.471-4.453-8.193-6.697l29.471-11.036l31.772,57.19C232.21,466.694,224.042,461.928,217.758,455.133z
               M247.467,444.94l-19.633-35.34h19.633V444.94z M247.467,392.533h-29.87l-19.196-25.6l19.196-25.6h29.87V392.533z
               M247.467,324.267h-30.925L167.779,281.6h43.347l36.34,14.522V324.267z M247.467,277.742l-26.508-10.592l-7.021-42.088
              l33.529-33.715V277.742z M112.078,162.133c0.44-13.876,3.243-27.575,8.289-40.508C135.4,91.1,182.433,42.667,244.658,42.667
              h22.683c62.225,0,109.258,48.433,124.292,78.958c5.042,12.934,7.844,26.633,8.285,40.508H256.007H112.078z M366.933,179.2v26.892
              l-45.014,5.623l16.169-32.515H366.933z M264.533,324.267v-28.145l36.341-14.522h43.347l-48.763,42.667H264.533z M313.6,366.933
              l-19.196,25.6h-29.87v-51.2h29.87L313.6,366.933z M264.533,277.742v-86.394l33.529,33.715l-7.021,42.088L264.533,277.742z
               M276.52,179.2h42.506l-14.168,28.494L276.52,179.2z M264.533,444.94V409.6h19.633L264.533,444.94z M323.817,429.375
              L323.817,429.375c-10.306,8.058-20.178,16.656-29.575,25.758c-6.285,6.797-14.454,11.566-23.463,13.698l31.776-57.198
              l29.47,11.035C329.297,424.917,326.549,427.156,323.817,429.375z M358.4,397.954c-2.222,2.542-4.385,4.883-6.417,6.946
              c-1.644,1.669-3.442,3.356-5.267,5.048l-34.39-12.878l16.203-21.603H358.4V397.954z M358.4,358.4h-29.871l-18.29-24.386
              l48.16-42.139V358.4z M362.942,264.533H308.78l5.791-34.704l60.371-7.538l19.21,4.796L362.942,264.533z M392.757,301.706
              c-0.091,0.5-0.137,1.007-0.135,1.515c-1.083,12.572-1.863,24.383-1.863,32.313c-1.509,14.362-6.784,28.071-15.292,39.741v-99.11
              l22.843-27.4C397.057,259.337,394.545,281.294,392.757,301.706z M400.815,210.456c-0.109,0.167-0.258,0.292-0.365,0.461
              c-0.029,0.046-0.028,0.1-0.056,0.146L384,206.966V179.2h16.816C401.14,189.896,401.088,200.623,400.815,210.456z M424.783,213.4
              L424.783,213.4c2.998-0.365,5.995,0.685,8.108,2.842c2.605,4.725,3.225,10.292,1.725,15.475
              c-2.073,10.509-5.039,20.821-8.867,30.825l-1.475,4.225c-1.125,3.258-2.083,6.692-3.05,10.142
              c-1.388,6.585-3.849,12.896-7.283,18.683c-0.843,1.437-2.182,2.516-3.766,3.034c2.404-26.118,5.796-53.814,5.866-54.426
              c0.113-1.279,1.057-12.163,1.638-27.388C419.638,214.968,422.12,213.776,424.783,213.4z"
            />
          </g>
        </g>
      </g>
    </symbol>
  </defs>
</svg>
